/*
 * Button styles with exclusion for React Query DevTools
 *
 * The :not(:global(.tsqd-parent-container) *) selectors are used to exclude
 * buttons that are inside React Query DevTools containers. This prevents
 * our button styles from interfering with the DevTools UI components.
 *
 * The :global() wrapper is needed because CSS Modules would otherwise
 * transform the class name with a prefix, making the selector ineffective.
 */

@layer legacy {
    /* Base button styles */
    .button:not(:global(.tsqd-parent-container) *),
    button:not([type='button']):not([class^='Mui']):not(:global(.tsqd-parent-container) *) {
        height: 42px;
        font-family: 'Averta', sans-serif;
        border-radius: var(--border-radius);
        background-color: var(--lime);
        color: var(--white);
        font-size: 16px;
        font-weight: 600;
        padding: 0 16px;
        cursor: pointer;
        border: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        outline: none;
    }

    /* Button content styles */
    .button:not([class^='Mui']):not(:global(.tsqd-parent-container) *) > p,
    button:not([type='button']):not([class^='Mui']):not(:global(.tsqd-parent-container) *) > p {
        width: fit-content;
    }

    /* Hover/active states */
    .button:is(:hover, .active):not([class^='Mui']):not(:global(.tsqd-parent-container) *),
    button:not([type='button']):is(:hover, .active):not([class^='Mui']):not(
            :global(.tsqd-parent-container) *
        ) {
        background-color: var(--lime-dark);
        transition: all 0.2s ease;
    }

    /* Button icon spacing */
    .button:not([class^='Mui']):not(:global(.tsqd-parent-container) *) > svg + *,
    button:not([type='button']):not(:global(.tsqd-parent-container) *) > svg + * {
        margin-left: 8px;
    }

    /* Full width variant */
    .button.fullWidth:not([class^='Mui']):not(:global(.tsqd-parent-container) *),
    button:not([type='button']).fullWidth:not(:global(.tsqd-parent-container) *) {
        width: 100%;
    }

    /* Danger variant */
    .button.danger:not([class^='Mui']):not(:global(.tsqd-parent-container) *),
    button:not([type='button']).danger:not(:global(.tsqd-parent-container) *) {
        background-color: var(--red);
    }

    /* Danger hover state */
    .button.danger:is(:hover, [aria-pressed='true']):not(:disabled):not([class^='Mui']):not(
            :global(.tsqd-parent-container) *
        ),
    button:not([type='button']).danger:is(:hover, [aria-pressed='true']):not(:disabled):not(
            :global(.tsqd-parent-container) *
        ) {
        background-color: var(--red-dark);
    }

    /* Secondary variant */
    .button.secondary:not([class^='Mui']):not(:global(.tsqd-parent-container) *),
    button:not([type='button']).secondary:not(:global(.tsqd-parent-container) *) {
        background-color: var(--white);
        color: var(--ink);
        border: 1px solid var(--ink-16);
        font-weight: normal;
    }

    /* Secondary hover state */
    .button.secondary:is(:hover, [aria-pressed='true']):not(:disabled):not([class^='Mui']):not(
            :global(.tsqd-parent-container) *
        ),
    button:not([type='button']).secondary:is(:hover, [aria-pressed='true']):not(:disabled):not(
            :global(.tsqd-parent-container) *
        ) {
        background-color: var(--white);
        border-color: var(--lime);
        color: var(--lime);
    }

    /* Secondary danger variant */
    .button.secondary.danger:not([class^='Mui']):not([disabled]):not(
            :global(.tsqd-parent-container) *
        ),
    button:not([type='button']).secondary.danger:not(:global(.tsqd-parent-container) *) {
        background-color: var(--white);
        border-color: var(--red);
        color: var(--red);
    }

    /* Secondary danger hover state */
    .button.secondary.danger:is(:hover, [aria-pressed='true']):not([class^='Mui']):not(
            :global(.tsqd-parent-container) *
        ),
    button:not([type='button']).secondary.danger:is(:hover, [aria-pressed='true']):not(
            :global(.tsqd-parent-container) *
        ) {
        background-color: var(--white);
        border-color: var(--red-dark);
        color: var(--red-dark);
    }

    /* Disabled state */
    .button:disabled:not([class^='Mui']):not(:global(.tsqd-parent-container) *),
    button:not([type='button']):not([class^='Mui']):disabled:not(
            :global(.tsqd-parent-container) *
        ) {
        cursor: no-drop;
        background-color: var(--paper-dark);
        color: var(--ink-lighter);
    }
}
